import { DateTime } from "luxon";
import { DeviceType, SessionLogs, SessionsLogs } from "./interfaces";

export const formatTimestampUTC = (timestamp: number): string =>
  DateTime.fromMillis(timestamp, { zone: "utc" }).toFormat(
    "yyyy-MM-dd HH:mm:ss",
  );

export const formatSessionsLogs = (
  sessionsLogs: SessionLogs[],
  device: DeviceType | null,
) =>
  sessionsLogs.reduce<SessionsLogs>(
    (acc, { deviceType, logs }) => {
      if (deviceType !== device) return acc;
      logs.forEach(({ frontendConsoleLogs, networkRequestData }) => {
        frontendConsoleLogs.logs.forEach(({ data, timestamp }) => {
          const { payload } = data;
          acc.consoleLogs.push({
            timestamp: `${timestamp}`,
            formattedTimestamp: formatTimestampUTC(timestamp),
            payload: payload.payload?.join(" ") || "",
            level: payload.level,
            trace: payload.trace,
            __typename: "ConsoleLog",
          });
        });
        networkRequestData.networkRequestData.forEach(
          ({ exceptions, logs, printStatements }) => {
            logs.forEach(({ data, timestampMs }) => {
              acc.backendLogs.push({
                timestamp: `${timestampMs}`,
                formattedTimestamp: formatTimestampUTC(timestampMs),
                statement: data.statement,
                level: data.level,
                __typename: "SailfishLog",
              });
            });

            printStatements.forEach(({ data, timestampMs }) => {
              acc.printStatements.push({
                timestamp: `${timestampMs}`,
                formattedTimestamp: formatTimestampUTC(timestampMs),
                statement: data.statement,
                output: data.output,
                __typename: "PrintStatement",
              });
            });

            exceptions.forEach(({ data, timestampMs }) => {
              acc.exceptions.push({
                timestamp: `${timestampMs}`,
                formattedTimestamp: formatTimestampUTC(timestampMs),
                exceptionMessage: data.exception_message,
                traceJson: data.trace_json,
                __typename: "SailfishException",
              });
            });
          },
        );
      });
      return acc;
    },
    { consoleLogs: [], backendLogs: [], printStatements: [], exceptions: [] },
  );
